import CommentForm from './comment-form';

export default CommentForm;
